import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: ["p", "br", "b", "strong", "i", "em", "u", "h2", "h3", "h4", "ul", "ol", "li", "a", "blockquote", "span"],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

export default function RichText({ html = "", className = "" }) {
  const clean = DOMPurify.sanitize(html || "", CONFIG);
  return <div className={`ztk-prose ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}

export function isHtml(str = "") {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}

export function toPlain(html = "") {
  if (typeof document === "undefined") return html.replace(/<[^>]+>/g, " ");
  const div = document.createElement("div");
  div.innerHTML = DOMPurify.sanitize(html || "", CONFIG);
  return (div.textContent || "").trim();
}
